import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editUserPreferences(
    request: Boundaries["editUserPreferences"]["request"],
  ): void;
}

function useUserPreferencesEdition(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isUserPreferencesEditionRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isUserPreferencesEditionRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isUserPreferencesEditionRequestFailure,
    ),
    editUserPreferences: core.editUserPreferences,
  };
}

export { useUserPreferencesEdition };
